import { AxiosResponse } from "axios";
import HttpService from "./interface/HttpService";
import { ProviderDashboardData } from "../model/provider/provider-dashboard-data";
import IGridHttpService from "./interface/IGridHttpService"
import { PaginatedList } from "../model/common/paginated-list";
import { OrderWithReducedDetails } from "../model/orders/orders";
import moment from "moment";
import { ProviderCustomerOrder } from "../model/customer/customer";

class SolarProviderService implements IGridHttpService {
    private instance: HttpService;
    private controllerName: string = 'solar-provider'; 

    constructor() {
        this.instance = new HttpService(this.controllerName);
    }

    public async getAllForGrid(obj: any) {
        return this.instance.get('grid-solar-providers', { params: { ...obj } });
    }

    public async getDashboardData(startDate: Date, endDate: Date): Promise<AxiosResponse<ProviderDashboardData>> {
        const start = moment(startDate).format();
        const end = moment(endDate).format();
        return this.instance.get('dashboard', { params: { startDate: start, endDate: end } });
    }

    public async getMostRecentOrders(page: number, pageSize: number, start: Date, end?: Date): Promise<AxiosResponse<PaginatedList<ProviderCustomerOrder>>> {
        return this.instance.get('dashboard/most-recent-orders', { params: { start, end, page, pageSize } }).then(response => {
            return Promise.resolve({
                ...response,
                data: {
                    ...response.data,
                    items: response.data.items.map((item: OrderWithReducedDetails) => {
                        return {
                            ...item,
                            paymentDate: item.paymentDate ? new Date(item.paymentDate) : undefined,
                            statusChanged : item.statusChanged ? new Date(item.statusChanged) : undefined
                        }
                    })
                }
            });
        });
    }

    public async getCompanyFirstLogin(companyId?: string): Promise<AxiosResponse<any>> {
        return this.instance.get('company', { params: { Id: companyId } });
    }

    public async fillCompanyInfo(data: any): Promise<AxiosResponse<any>> {
        return this.instance.post('fill-company-info', data);
    }

    public async getAllTeamMembers(search: string): Promise<AxiosResponse<any>> {
        return await this.instance.get('get-all-team-members', { params : { search }});
    }

    public async removeTeamMember(obj: any): Promise<AxiosResponse<any>> {
        return await this.instance.post('remove-team-member', obj);
    }

    public async toggleActivateTeamMember(obj: any): Promise<AxiosResponse<any>> {
        return await this.instance.post('toggle-team-member-activity', obj);
    }

    public async getAllPermissions(): Promise<AxiosResponse<any>> {
        return await this.instance.get('get-all-permissions');
    }

    public async inviteNewTeamMember(obj: any): Promise<AxiosResponse<any>>  {
        return await this.instance.post('invite-new-team-member', obj);
    }

    public async confirmNewMemberInvitation(obj: any): Promise<AxiosResponse<any>>  {
        return await this.instance.post('confirm-new-team-member-invitation', obj);
    }

    public async registerNewSolarProvider(obj: any): Promise<AxiosResponse<any>>  {
        return await this.instance.post('new-solar-provider', obj);
    }
}

const solarProviderService = new SolarProviderService();

export default solarProviderService;
